import React from 'react';

export default function Header() {
  return (
    <section>
      <h1>Profile</h1>
    </section>
  );
}
